import React from 'react';
import './ChartCard.css';

/**
 * Reusable card wrapper for charts with glass‑morphism styling.
 * Props:
 *   - title: string – displayed in the header with an optional icon.
 *   - children: ReactNode – the chart component.
 */
const ChartCard = ({ title, children }) => {
  return (
    <div className="chart-card glass-card">
      <div className="chart-card-header">
        <h5>{title}</h5>
      </div>
      <div className="chart-card-body">{children}</div>
    </div>
  );
};

export default ChartCard;
